import { AuthWelcome } from './AuthService';
import { TRecentParams } from './filter/FilterContainer';
import {
  ICalendarEventsProperty,
  IQuotePropertyParams,
} from './interfaces/hostfully.property.interface';

const Auth = new AuthWelcome();

export const API_WELCOME = {
  getProperties: function (params: TRecentParams) {
    return Auth.get('properties', params);
  },
  getNeighborhoods: function () {
    return Auth.get('properties/neighborhoods', {});
  },
  getPropertyPhotos: function (propertyId: string) {
    return Auth.get('propertyPhotos', propertyId);
  },
  getPropertyQuote: function (params: IQuotePropertyParams) {
    return Auth.get('properties/propertyQuote', params);
  },
  getCalendarEvents: function (params: ICalendarEventsProperty) {
    return Auth.get('properties/calendarEvents', params);
  },
};

export default API_WELCOME;
